import {
  AuthOnFile,
  JCodeDocuments,
} from "../../../data-model/medicalPaOrdersModel";
import { getAllJCodesFromAuthOnFile } from "./existingDocsToLs";

export const getAllUniqueDocsFromJCodesInFlattenedArray = (
  authOnFileDetails: AuthOnFile,
): JCodeDocuments[] => {
  if (!authOnFileDetails) return [];
  const jcodes = getAllJCodesFromAuthOnFile(authOnFileDetails);
  const docsFromEveryJcodes = jcodes
    ?.map((jcode) => jcode.documents)
    .flat()
    .filter((doc): doc is JCodeDocuments => doc !== undefined && doc !== null);

  // Dedup by `doc_path`, but prefer the copy that carries a meaningful
  // `doc_title`. Naively constructing `new Map(pairs)` would let the last
  // occurrence win, which often has `doc_title: null` and loses the
  // descriptive title coming from another duplicate.
  const uniqueDocsMap = new Map<string | undefined, JCodeDocuments>();
  for (const doc of docsFromEveryJcodes ?? []) {
    const existing = uniqueDocsMap.get(doc.doc_path);
    if (!existing) {
      uniqueDocsMap.set(doc.doc_path, doc);
      continue;
    }
    if (!existing.doc_title && doc.doc_title) {
      uniqueDocsMap.set(doc.doc_path, doc);
    }
  }
  const uniqueDocs: JCodeDocuments[] = Array.from(uniqueDocsMap.values());
  return uniqueDocs;
};
